"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialType = void 0;
/**
 * Type
 */
var CommercialType;
(function (CommercialType) {
    CommercialType["TV"] = "TV";
    CommercialType["Radio"] = "Radio";
    CommercialType["Digital"] = "Digital";
    CommercialType["Print"] = "Print";
    CommercialType["OOH"] = "OOH";
    CommercialType["Social"] = "Social";
    CommercialType["BTS"] = "BTS";
    CommercialType["Other"] = "Other";
})(CommercialType || (exports.CommercialType = CommercialType = {}));
//# sourceMappingURL=commercial-types.js.map